module.exports = __webpack_public_path__ + "static/img/bigdata5.155a382.png";


//////////////////
// WEBPACK FOOTER
// ./public/hadoopImg/bigdata5.png
// module id = y83Y
// module chunks = 0